import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';
import { CgMenuRightAlt } from 'react-icons/cg';
import { FaWhatsapp, FaEnvelope, FaArrowUp, FaFacebookF, FaTwitter, FaTelegramPlane, FaInstagram } from 'react-icons/fa'; 
import logo from '../images/weblogo.png';
import '../index.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showNavbar, setShowNavbar] = useState(true);
  const [lastScrollPos, setLastScrollPos] = useState(0);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      setShowNavbar(lastScrollPos > currentScrollPos || currentScrollPos <= 0);
      setLastScrollPos(currentScrollPos);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollPos]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleToggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleServicesClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <header className={`fixed top-0 w-full z-30 shadow-md bg-white transition-transform duration-300 ${showNavbar ? 'translate-y-0' : '-translate-y-full'}`}>
      <div className="md:mx-4 flex flex-wrap items-center justify-between px-4">
        <Link to={'/'} className="text-sm md:text-2xl lg:text-2xl xl:text-2xl flex items-center mt-4 py-1 -ml-2" onClick={scrollToTop}>
          <img src={logo} alt="This is an image" className='w-8 -mt-4 mr-1 h-12' />
        </Link>
        <Link to={'/'}>
          <p className="text-3xl font-bold uppercase -ml-18 md:ml-18 mt-6 text-blue-600">
            Net<span className="text-green-500 uppercase">Sage</span>
          </p>
        </Link>
        <button
          className="md:hidden text-gray-800 navbar-icon relative"
          onClick={handleToggleMenu}
        >
          <CgMenuRightAlt className='-mr-2 font-bold rounded-md text-gray-500 hover:text-gray-800' style={{ fontSize: `30px` }} />
        </button>

        {/* Navbar for medium and small screens */}
        <nav className={`md:hidden fixed top-0 left-0 h-full bg-white z-100 w-74 px-4 py-1 transform duration-300 ${isOpen ? 'translate-x-0' : ' -translate-x-80'}`}>
          <div className="flex flex-col bg-white absolute top-0 left-0 py-3 px-8 z-50 w-64" style={{ height: `100vh` }}>
            <Link to={'/'} className="link-underline text-sm md:text-2xl lg:text-2xl xl:text-2xl flex flex-col items-center mt-1" onClick={() => { setIsOpen(false); scrollToTop(); }}>
              <p className="text-3xl font-bold uppercase -ml-16 text-blue-600">
                Net<span className="text-green-500 uppercase">Sage</span>
              </p>
            </Link>
            <div className='mt-0 flex flex-col'>
              <Link to={'/'} className="link-underline text-gray-800 mb-4" onClick={() => { setIsOpen(false); scrollToTop(); }}>Home</Link>
              <Link to={'/about'} className="link-underline text-gray-800 mb-4" onClick={() => { setIsOpen(false); scrollToTop(); }}>About</Link>
              {/* Services accordion for small screens */}
              <div className="relative mt-0 mb-4">
                <button
                  className="text-gray-800 focus:outline-none flex items-center"
                  onClick={handleServicesClick}
                >
                  Services
                  {isDropdownOpen ? (
                    <IoMdArrowDropup className="ml-1 text-gray-500" style={{ fontSize: `24px` }} />
                  ) : (
                    <IoMdArrowDropdown className="ml-1 text-gray-500" style={{ fontSize: `24px` }} />
                  )}
                </button>
                {isDropdownOpen && (
                  <div className="mt-2 space-y-2 w-96 -ml-6">
                    <Link to={'logo-designing'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={() => { setIsOpen(false); scrollToTop(); }}>Logo Designing</Link>
                    <Link to={'product-flyer'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={() => { setIsOpen(false); scrollToTop(); }}>Product Flyers</Link>
                    <Link to={'graphic-designing'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={() => { setIsOpen(false); scrollToTop(); }}>Graphic Designing</Link>
                    <Link to={'web-development'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={() => { setIsOpen(false); scrollToTop(); }}>Web Development</Link>
                    <Link to={'app-development'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={() => { setIsOpen(false); scrollToTop(); }}>App Development</Link>
                    <Link to={'see-all'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={() => { setIsOpen(false); scrollToTop(); }}>Software Development</Link>
                  </div>
                )}
              </div>
              <Link to={'/contact'} className="link-underline text-gray-800" onClick={() => { setIsOpen(false); scrollToTop(); }}>Contact</Link>
            </div>
          </div>
        </nav>

        {/* Navbar for larger screens */}
        <nav className={`hidden md:flex md:flex-row md:items-center md:w-auto w-full ${isOpen ? 'flex' : 'hidden'}`}>
          <div className="flex flex-col md:flex-row md:items-center md:w-auto w-full">
            <Link to={'/'} className="link-underline block md:inline-block text-gray-800 mr-4 md:mt-0 mt-2 md:ml-4" onClick={scrollToTop}>Home</Link>
            <div
              ref={dropdownRef}
              className="relative md:inline-block mt-2 md:mt-0 md:ml-4 services-dropdown"
              onMouseEnter={() => setIsDropdownOpen(true)}
              onMouseLeave={() => setIsDropdownOpen(false)}
            >
              <button
                className="text-gray-800 focus:outline-none flex items-center"
                onClick={toggleDropdown}
              >
                Services
                {isDropdownOpen ? (
                  <IoMdArrowDropup className="ml-1 text-gray-800" style={{ fontSize: `20px` }} />
                ) : (
                  <IoMdArrowDropdown className="ml-1 text-gray-800" style={{ fontSize: `20px` }} />
                )}
              </button>
              {isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg">
                  <Link to={'logo-designing'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={scrollToTop}>Logo Designing</Link>
                  <Link to={'product-flyer'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={scrollToTop}>Product Flyers</Link>
                  <Link to={'graphic-designing'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={scrollToTop}>Graphic Designing</Link>
                  <Link to={'web-development'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={scrollToTop}>Web Development</Link>
                  <Link to={'app-development'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={scrollToTop}>App Development</Link>
                  <Link to={'see-all'} className="link-underline block px-4 py-2 text-gray-800 hover:bg-gray-200" onClick={scrollToTop}>Software Development</Link>
                </div>
              )}
            </div>
            <Link to={'/about'} className="link-underline block md:inline-block text-gray-800 mr-4 md:mt-0 mt-2 md:ml-4" onClick={scrollToTop}>About</Link>
            <Link to={'/contact'} className="link-underline block md:inline-block text-gray-800 md:ml-4 md:mt-0 mt-2" onClick={scrollToTop}>Contact</Link>
          </div>
        </nav>

   {/* Social Media and Contact Icons */}
<div className="block items-center space-x-4 absolute top-80 left-2 ml-4">
  <a href="https://wa.me/+447902408574" target="_blank" rel="noopener noreferrer">
    <FaWhatsapp className="text-green-500 text-2xl icon-animation hover:animate-bounce" />
  </a>
  <a href="https://web.facebook.com/profile.php?id=61561189633389" target="_blank" rel="noopener noreferrer">
    <FaFacebookF className="text-blue-600 text-2xl icon-animation hover:animate-bounce" />
  </a>
  <a href="https://x.com/Netsagetech" target="_blank" rel="noopener noreferrer">
    <FaTwitter className="text-blue-400 text-2xl icon-animation hover:animate-bounce" />
  </a>
  <a href="https://t.me/netsagetechnologies" target="_blank" rel="noopener noreferrer">
    <FaTelegramPlane className="text-blue-500 text-2xl icon-animation hover:animate-bounce" />
  </a>
  <a href="https://www.instagram.com/netsagetech/" target="_blank" rel="noopener noreferrer">
    <FaInstagram className="text-pink-600 text-2xl icon-animation hover:animate-bounce" />
  </a>
</div>



        <button onClick={scrollToTop} className='p-2 bg-blue-500 top-96 right-3 absolute mt-36' style={{borderRadius:`100%`}}>
            <FaArrowUp className="text-white text-3xl " />
          </button>
      </div>
    </header>
  );
};

export default Navbar;
